import http from './http.request'

const getHolidaysData = async () => {
    try {
        const holidaysJsonUrl = '/hotel-business/search-panel/jp-holidays.json'
        // const holidaysJsonUrl = 'https://d-reserve.jp/hotel-business/search-panel/jp-holidays.json'
        const response = await http.get(holidaysJsonUrl)
        return JSON.parse(response)
    } catch (error) {
        console.log(error)
        return {}
    }
}

// TODO flatpickr の初期化に関する処理もここに統合していく

export {
    getHolidaysData,
}
